export default __webpack_public_path__ + "static/media/importFile.11c00723.svg";